<template>
<!-- 
  - Get results from Directus API
  - Display static information about the selected NAICS code. 
-->
  <div class="divscroll detail-class" ref="contentTop">
    <v-touch tag="div" v-on:swiperight="swipeBack()" class="scrollpane">
      <b-button v-if="mx_isMobile()" class="is-info is-small" @click="swipeBack()"><b-icon class="back-icon" icon="caret-left"></b-icon> {{ $t("back") }}</b-button>
      <a tabindex="0" id="detailHeader" ref="detailHeader" href="#treeHeader" class="show-on-hover skip-text">
        {{ $t('skip_to_tree') }}
      </a>
      <div v-if="this.getShowDetail">
        <div class="content">
          <div>
            <div class="naicscode" :aria-label="$t('aria_label_code')">{{ this.bpdata_id }}</div>
            <h1
              v-if="this.details[`title_${this.lang}`] && this.details[`title_${this.lang}`].length !== undefined"
              :aria-label="$t('aria_label_title')"
            >{{ this.details[`title_${this.lang}`] }}</h1>
            <b-field v-if="mx_isMobile()" :class="checkboxAppearance">
              <label for="checkbox" class="visuallyhidden">{{ this.bpdata_id }}-{{ this.details[`title_${this.lang}`] }}</label>
              <b-radio v-if="!this.multiple && this.checkIfSelectable" id="checkbox" native-value="true" role="radio" v-model="haschecked"></b-radio>
              <b-checkbox v-if="this.multiple && this.checkIfSelectable" id="checkbox" role="checkbox" type="is-info" v-model="haschecked"></b-checkbox>
              <b-collapse 
                :open="false" 
                position="is-bottom" 
                aria-id="contentIdForInfo2"
                v-if="this.checkIfSelectable"
              >
                <template #trigger="props">
                  <a aria-controls="contentIdForInfo2">
                    <b-icon type="is-info" :icon="!props.open ? 'caret-down' : 'caret-up'"></b-icon>
                    <b-icon type="is-info" icon="info-circle" size="is-small"></b-icon>
                  </a>
                </template>
                <p>
                  <small>{{ $t('info_checkbox_text') }}</small>
                </p>
              </b-collapse>
            </b-field>
            <p>
              {{ this.details[`definition_${this.lang}`] }}
            </p>
            <br />
          </div>
          <div v-if="undefined !== this.details[`inclusions_${this.lang}`] && this.details[`inclusions_${this.lang}`].length">
            <b>{{ $t("includes_text") }}</b>      
            <ul role="list">
              <li role="listitem" v-for="inc in this.details[`inclusions_${this.lang}`]" :key="inc.id">{{ inc.inclusion }}</li>
            </ul>
          </div>
          <div v-if="undefined !== this.details[`exclusions_${this.lang}`] && this.details[`exclusions_${this.lang}`].length">
            <b>{{ $t("excludes_text") }}</b>      
            <ul role="list">
              <li role="listitem" v-for="exc in this.details[`exclusions_${this.lang}`]" :key="exc.id">{{ exc.exclusion }}</li>
            </ul>
          </div>
          <div v-if="undefined !== this.sortedExamples && this.sortedExamples.length">
            <b>{{ $t("examples_text") }}</b>      
            <ul role="list">
              <div v-for="ex, index in this.sortedExamples" :key="ex.id">
                <li role="listitem" v-if="index <= 4" v-html="highlightExamples(ex.example)"></li>
              </div>
            </ul>
            <b-button
              v-if="this.sortedExamples.length >= 5"
              type="is-info detail-button is-small"
              @click="GAHandler(isHidden)"
              :icon-right="isHidden ? 'plus' : 'minus'"
              :label="$t('more')"
              :aria-label="$t('aria_label_more')"
            ></b-button>
            <ul v-show="!isHidden" role="list">
              <div v-for="ex, index in this.sortedExamples" :key="ex.id">
                <li role="listitem" v-if="index >= 5" v-html="highlightExamples(ex.example)"></li>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <p class="title is-6">{{ $t("naics") }}</p>
          <p>
            {{ $t("naics_desc") }}
          </p>
          <p class="source">
            <span v-html="$t('source_text')"></span><span v-if="mx_isMobile()"><br /></span><span v-html="$t('naics_source')"></span>
          </p>
          <p class="powered-by">{{ $t('powered_by') }} <a :href="this.bpLink" v-html="$t('bizpal')" target="_blank"></a></p>
        </div>
      </div>
    </v-touch>
  </div>
</template>

<script>
import Vue from "vue";
var VueTouch = require('vue-touch');
Vue.use(VueTouch, {name: 'v-touch'});
VueTouch.config.swipe = {
  direction: 'horizontal'
}
import { getAPIConnexion } from "../services/API_Directus.js";

export default {
  name: "DetailPane",
  i18n: {
    locale: "en",
    messages: {
      en: {
        naics: "North American Industry Classification System (NAICS)",
        naics_desc: "The North American Industry Classification System (NAICS) has been developed by the statistical agencies of Canada, Mexico and the United States.",
        source_text: "Source:&nbsp;",
        naics_source: '<a href="https://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=1181553" target="_blank">NAICS Canada 2017, Statistics Canada</a>',
        examples_text: "Examples",
        includes_text: "Includes",
        excludes_text: "Excludes",
        have_selected: "You've have selected ",
        industry_word: "industry | industries",
        more: "More",
        info_checkbox_text: "Check or uncheck for selection in tree",
        back: "Back",
        powered_by: "Powered by",
        bizpal: "BizPaL",
        skip_to_tree: "Skip to results",
        aria_label_code: "North Americain Industry Classification System Code for this industry",
        aria_label_title: "North Americain Industry Classification System Title for this industry",
        aria_label_more: "to list more examples for this industry"
      },
      fr: {
        naics: "Système de classification des industries de l'Amérique du Nord (SCIAN)",
        naics_desc: "Le Système de classification des industries de l'Amérique du Nord (SCIAN) a été conçu par les organismes statistiques du Canada, du Mexique et des États-Unis.",
        source_text: "Source&nbsp;:&nbsp;",
        naics_source: '<a href="https://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=1181553" target="_blank">SCIAN Canada 2017, Statistique Canada</a>',
        examples_text: "Exemples",
        includes_text: "Comprend",
        excludes_text: "Exclut",
        have_selected: "Vous avez choisi ",
        industry_word: "secteur d'activité | secteurs d'activités",
        more: "Plus",
        info_checkbox_text: "Cocher ou décocher pour sélection dans l'arbre",
        back: "Retour",
        powered_by: "Proposé par",
        bizpal: "PerLE",
        skip_to_tree: "Passer aux résultats",
        aria_label_code: "Code du Système de classification des industries de l'Amérique du Nord pour cette industrie",
        aria_label_title: "Titre du Système de classification des industries de l'Amérique du Nord pour cette industrie",
        aria_label_more: "pour afficher plus d'exemples de la liste pour cette industrie"
      }
    }
  }, // end i18n
  props: {
    lang: {
      type: String,
      default: "en"
    },
    bpdata_id: {
      type: String,
      default: ""
    },
    bpdata_this: { // getting 'this' from parent
      type: Object,
      default: function() {
        return {}
      }
    }
  }, // end props
  data: function() {
    return {
      details: {},
      isHidden: true,
      sortedExamples: [],
      allDefinition:[],
      haschecked: false,
      bpLink: "https://services.bizpal-perle.ca/"
    };
  }, // end data
  created: function() {
    this.$i18n.locale = this.mx_toggleLang;
  }, // end created
  mounted: function() {
    // use case when select naics is the same, so watch bpdata_id not being executed
    if (Object.keys(this.details).length === 0 && this.bpdata_id) {
      this.details = this.getAllIndustriesDirectus[this.bpdata_id];    
    }
    if (this.$i18n.locale == 'fr') {
      this.bpLink = "https://services.perle-bizpal.ca/?lang=fr";
    } else {
      this.bpLink = this.bpLink + "?lang=en";
    }
  }, // end mounted
  computed: {
    toggleDetail: function() {
      return this.detailShow;
    }, // end toggleDetail
    checkboxAppearance: function() {
      var displayClass = "";
      if (!this.multiple) {
        displayClass = "display-as-radio-button";
      }
      return displayClass;
    }, //end checkboxApparearance
    checkIfSelectable: function() {
      if (this.getNodeInfo.level >= this.getLevelSelectable[0]) {
        return true;
      } else {
        return false;
      }
    } // end checkIfSelectable
  }, // end computed
  watch: {
    bpdata_id: function() {
      var idSel = this.bpdata_id;
      let allChecked = this.getAllCheckedValues;
      if (allChecked.naics.length > 0) {
        let elements = allChecked.naics;
        var ind = elements.findIndex(function(i) {
          return i.code == idSel;
        });
        if (ind != -1) {
          this.haschecked = true;
        } else {
          this.haschecked = false;
        }
      }
      // safe guard in case, download not done
      // for all definition for industries
      this.allDefinition = this.getAllIndustriesDirectus;
      if (Object.keys(this.allDefinition).length == 0) {
        //get for that ID
        let query = `id: {_eq: "${this.bpdata_id}"}`; 
        let lang = (this.lang) ? this.lang : "en";

        getAPIConnexion(query, lang, process.env.VUE_APP_DIRECTUS)
          .then(response => {
            this.details = (response.data === undefined && response.data.data === undefined) ? null : response.data.data["naics_2017"][0];
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.details = this.allDefinition[this.bpdata_id];          
      }

      if (this.details) {
        this.updateShowDetail(true);
        this.sortExamples();
        this.$refs.contentTop.scrollTop = 0;
      } else {
        this.updateShowDetail(false);
      }
    }, // end bpdata_id
    term: function() {
      this.detailShow = false;       
    }, // end term
    haschecked: function() {
      let allChecked = this.getAllCheckedValues;
      let elements = allChecked.naics;
      var idSel = this.bpdata_id;
      let naicsInfo  = this.getAllIndustriesDirectus[this.bpdata_id];  
      if (this.haschecked) {
        // add id to select
        if (!this.multiple) {
          elements = [];
          elements.push({
            code: this.bpdata_id,
            name: naicsInfo != undefined ? naicsInfo[`title_${this.lang}`] : "",
            examples: []
          });
        } else {
          // make sure naics code is not already in array           
          var ind = elements.findIndex(function(i) {
            return i.code == idSel;
          });
          if (ind < 0 ) {
            elements.push({
              code: this.bpdata_id,
              name: naicsInfo != undefined ? naicsInfo[`title_${this.lang}`] : "",
              examples: []
            });
          }
        }
        this.updateHasNoSelection(false);
      } else {
        var ind = elements.findIndex(function(i) {
          return i.code == idSel;
        });
        if (ind >= 0) {
          elements.splice(ind, 1);
        }
        // remove id 
        this.$emit("uncheckedid", this.bpdata_id);        
      } //end else
      this.updateAllChecked({
        key: "naics",
        payload: elements
      });
    }, // end haschecked    
    getAllCheckedValues: {
      handler: function(newVal) {
        var idSel = this.bpdata_id;
        if (newVal.length != 0) {
          var ind = newVal.naics.findIndex(function(i) {
            return i.code == idSel;
          });
          if (ind != -1) {
            this.haschecked = true;
          } else {
            this.haschecked = false;
          }
        }
      },
      deep: true
    }, // end getAllCheckedValues
    lang: function() {
      this.$i18n.locale = this.mx_toggleLang;
    } // end lang
  }, // end watch
  methods: {
    swipeBack: function() {
      if (this.mx_isMobile()) {
        this.bpdata_this.$refs.tinySlider.slider.goTo(0);
      }
    },
    sortExamples: function() {
      let naicsCode = this.bpdata_id;
      let examplesFromHits = (this.getHasExampleByNaics[0] == undefined || this.getHasExampleByNaics[0][`${naicsCode}`] == undefined ) ? []: JSON.parse(JSON.stringify(this.getHasExampleByNaics[0][`${naicsCode}`])); 
      let examplesfromDirectus = [];
      if (this.details[`examples_${this.lang}`]) {
        examplesfromDirectus = this.details[`examples_${this.lang}`];
      }
      let arrayIDFromHit = [];

      examplesFromHits.forEach(object => {
        arrayIDFromHit.push(object.id);
      });

      // create array that have exemples from hits on top
      examplesfromDirectus.forEach(object => {
        if (arrayIDFromHit.indexOf(object.id) < 0) { // don't add if examples is the same that from HIT
          examplesFromHits.push(object);
        }
      });
    
      this.sortedExamples = examplesFromHits;      
    }, // end sortExamples
    highlightExamples: function(example) {
      let output = "";
      // since match words are tag with <em> , match with those < and >
      let regex = new RegExp("<.*?>", 'gi');
      // highlight keyword matches in the examples
      output += example.replace(regex, '<span class="highlight">$&</span>');           
      return output;
    }, // end highlightExamples
    GAHandler: function (val) {  
      // because user clicked, set opposite value;
      this.isHidden = !val;
      let result = this.isHidden ? "collapse" :"expanded"    
      this.$gtag.customMap({ 'dimension3': "keyword", "dimension2": "naics" });
      this.$gtag.event("more-clicked", {
        event_category: "naics-tree-widget",
        event_label: `user clicked on more on detail pane (${this.bpdata_id}): ${result}`,
        naics: this.bpdata_id ,
        product: process.env.VUE_APP_PRODUCT
      });   
    } // end GAHandler
  } // end methods
}; // end export default
</script>

<style scoped>
.open-services-tree-naics-lookup ul {
  list-style: disc inside;
  margin-top: 1em;
}
.open-services-tree-naics-lookup .result {
  list-style: none;
  margin-left: 0em;
  margin-top: 0em;
}
.open-services-tree-naics-lookup .content {
  font-size: 90%;
  padding-right: 20px;
}
.open-services-tree-naics-lookup .content h1 {
  font-size: 150%;
  margin-top: 0;
}
.open-services-tree-naics-lookup .content ul {
  list-style: disc;
  margin: 0.2em 0 1.2em 0;
  padding: 0 0 0 1.5em;
}
.open-services-tree-naics-lookup .content ul li {
  line-height: 1.2em;
  padding: 3px 0;
}
.open-services-tree-naics-lookup .content .naicscode {
  font-weight: 500 !important; 
  color: #444;
  font-size: 16px;
  vertical-align: bottom;
  font-family: monospace;
}
.open-services-tree-naics-lookup .detail-button {
  font-weight: bold;
  margin-bottom: 10px;
  background-color: #38598a;
  color: #ffffff;
}
.open-services-tree-naics-lookup .detail-button:focus {
  background-color: #167df0;
  color: rgba(255,255,255,1);
  margin-right: 6px;
}
.open-services-tree-naics-lookup .highlight {
  font-weight: 500;
  background-color: #fdfae0;
}
.open-services-tree-naics-lookup em {
  font-weight: 500;
  background-color: #fdfae0;
}
.open-services-tree-naics-lookup .source {
  font-size: small;
  margin-top: 10px;
}
.open-services-tree-naics-lookup .visuallyhidden {
  display: none;
}
.open-services-tree-naics-lookup .back-icon {
  display: inline-block !important;
}
.open-services-tree-naics-lookup .skip-text {
  font-size: 90%;
}
.open-services-tree-naics-lookup .show-on-hover {
  opacity: 0;
  width: 0;
  height: 0;
  line-height: 0;
  position: absolute;
}
.open-services-tree-naics-lookup .show-on-hover:focus {
  opacity: 1;
  width: 30%;
  display: inline-block;
  height: 18px;
  line-height: 18px;
  position: relative;
}
.open-services-tree-naics-lookup .powered-by {
  font-size: 95%;
  font-weight: 400;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  margin-top: 45px;
}
@media (max-width: 767px) {
  .open-services-tree-naics-lookup .detail-class {
    margin-left: 5px;
  }
}
</style>
